import { Component, ElementRef, EventEmitter, Injector, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';


import { ButtonTypesEnum } from '../../../Forms/enums/button-types.enum';
import { CoreDialogService } from '../../../../Core/Dialogs/services/dialog.service';
import { AnalysisUpsellPopupComponent } from '../../../../Monitor/Briefings/components/AnalysisUpsellPopup/analysis-upsell-popup.component';
import { MonitorConfigService } from '../../../MonitorShared/services/monitor-config.service';
import { catchError, combineLatest, of, Subscription } from 'rxjs';
import { DropdownOptionModel } from '../../../Forms/models/dropdown-option.model';
import {
    getMonitoringDateQueryInputFolderOptions,
    getMonitoringDateQueryInputTopicOptions
} from '../../../../Monitor/Shared/models/monitoring-date-query-input-options';
import { SearchRangeModel } from '../../../../Monitor/Core/models/search-range.model';
import { DateQueryModel } from '../../../Forms/models/date-query.model';
import { ReportSeriesModel } from '../../models/report-series.model';
import { KeyMessageGroupApi } from '../../../../api/ai/model/key-message-group-api.';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActionKeys } from '../../../Forms/enums/keys.enum';
import { CoverageAnalysisService } from '../../../../Monitor/Shared/services/coverage-analysis.service';
import { CoverageInsights } from '../../../../Monitor/Shared/models/coverage-insights.model';
import { AiAnalysisTypes } from '../../../Mentions/enums/ai-analysis-types.enum';
import { messageSeverityEnum } from '../../../Misc/enums/message-severity.enum';
import { promptLanguageOptions } from '../../../Forms/data/prompt-language-options';
import { PromptModel } from '../../../Mentions/models/prompt.model';
import { MessageService } from 'primeng/api';
import { LocalizationService } from '../../../../Core/Localization/services/localization.service';
import { SearchStatesEnum } from '../../../../Monitor/Shared/enums/search-states.enum';
import { DateQueryTypeEnum } from '../../../../api/mentions/enum/date-query-type.enum';
import { CurrentUserStateService } from '../../../../Core/Users/services/current-user-state.service';
import { ReportsDashboardSearchService } from '../../services/reports-dashboard-search.service';
import { ScrollPanelComponent } from '../../../Basic/components/ScrollPanel/scroll-panel.component';
import { MentionSearchCriteriaModel } from '../../../../Monitor/Shared/models/mention-search-criteria.model';
import { CoverageInsightConfigModel } from '../../models/coverage-insight-config.model';
import { ContentTypeEnum } from '../../../../api/ai/enums/content-type.enum';
import { CompletionTargetAudienceEnum } from '../../../../api/ai/enums/completion-target-audience.enum';
import { GoalTypeEnum } from '../../../../api/ai/enums/goal-type.enum';
import { CompletionToneEnum } from '../../../../api/ai/enums/completion-tone.enum';
import { PositionSuggestionApi } from '../../../../api/ai/model/position-suggestion-api.';
import { ActionAssistantResponseApi } from '../../../../api/ai/model/action-assistant-response-api';
import { BulkAnalysisResponseApi } from '../../../../api/ai/model/bulk-analysis-response-api';
import { AiDistributionContent } from '../../../../Discover/Targeting/components/Distribution/AIQuickDistributionDialog/ai-quick-distribution-dialog.component';
import { languageDataLocalizationMap } from '../../../../Core/Localization/language-localization.model';
import { RichTextEditorConfigModel } from '../../../Forms/components/RichTextEditorCK/model/rich-text-editor-config.model';

@Component({
    selector: 'agpr-action-assistant',
    templateUrl: './action-assistant.component.html',
    styleUrls: ['./action-assistant.component.scss'],
    animations: [
        trigger('toggleContent', [
            state('collapsed', style({
                height: '{{height}}',
            }), { params: { height: '88px' } }),
            state('expand', style({
                height: '*',
            })),
            transition('collapsed <=> expand', animate('400ms cubic-bezier(0.86, 0, 0.07, 1)'))
        ])
    ],
    standalone: false
})

export class ActionAssistantComponent implements OnInit, OnDestroy {
    readonly buttonTypes = ButtonTypesEnum;
    readonly aiPopupWidth: number = 485;
    readonly aiPopupHeight: number = 372;
    readonly messageSeverityEnum = messageSeverityEnum;
    readonly promptLanguageOptions = promptLanguageOptions;
    readonly aiAnalysisTypes = AiAnalysisTypes;

    @Input() drilldownSeries: ReportSeriesModel;
    @Input() set coverageInsightConfig(config: CoverageInsightConfigModel) {
        if (config) {
            this.keyMessageGroups = config.keyMessageGroups;
            // this.mentions = config.mentions;
            this.skipClearState = true;
        }
    };

    @Input() set externalKeyMessageGroups(groups: KeyMessageGroupApi[]) {
        if (groups !== null && groups !== undefined) {
            this.keyMessageGroups = groups;
        }
    }
    @Output() keyMessageGroupsChanged = new EventEmitter<KeyMessageGroupApi[]>();
    @Output() dateChanged = new EventEmitter<DateQueryModel>();
    @Output() emitSourceChanged = new EventEmitter<ReportSeriesModel>();

    @ViewChild('settingsScrollPanel') settingsScrollPanel: ScrollPanelComponent;
    @ViewChild('keyMessageScrollPanel') keyMessageScrollPanel: ScrollPanelComponent;
    @ViewChild('contentScrollPanel') contentScrollPanel: ScrollPanelComponent;
    @ViewChild('positionField') positionFieldEl!: ElementRef;
    @ViewChild('positionSuggestionsList') positionSuggestionsListEl!: ElementRef;
    @ViewChild('positionSuggestionsPopup') positionSuggestionsPopupEl!: ElementRef;
    @ViewChild('aiButton') aiButtonEl!: ElementRef;
    @ViewChild('contentTypeField') contentTypeFieldEl!: ElementRef;

    id: string = 'action_assistant';
    hasCoverageInsightsEnabled = false;
    overlayContainer: Element;
    protected subscriptions: Subscription[] = [];

    dateOptions: DropdownOptionModel[] = getMonitoringDateQueryInputTopicOptions();
    searchRange: SearchRangeModel = null;
    dateQuery: DateQueryModel;
    mentionCount: number = 0;
    warningMentionCount: number = 400;
    errorMentionCount: number = 10000;
    animating: boolean = false;
    userDefinedKeyMessageString: string;
    keyMessageGroups: KeyMessageGroupApi[] = [];
    collapsed: boolean = true;
    loading: boolean = false;
    hasGenerated: boolean = false;
    generatedContentTypeLabel: string = '';
    generatedContentType: ContentTypeEnum | null = null;
    generatedResponse: ActionAssistantResponseApi = null;
    ckEditorConfig: RichTextEditorConfigModel;


    showBackButton: boolean = false;
    cachedSearchCriteria: MentionSearchCriteriaModel;
    skipClearState: boolean = false;
    analysisContext: string = '';

    selectedLanguage;

    settingsForm: FormGroup;

    contentType: ContentTypeEnum;
    targetAudience: CompletionTargetAudienceEnum;
    goal: GoalTypeEnum;
    completionTone: CompletionToneEnum;

    position: string;

    contentTypeOptions$ = of([]);
    goalOptions$ = of([]);
    targetAudienceOptions$ = of([]);
    toneOptions$ = of([]);
    languageOptions$ = of([]);

    positionSuggestions: PositionSuggestionApi[] = [];
    loadingPositionSuggestions: boolean = false;
    positionSuggestionsTop: number = 0;
    positionSuggestionsLeft: number = 0;


    constructor(
        private injector: Injector,
        private coreDialogService: CoreDialogService,
        private monitorConfigService: MonitorConfigService,
        private mentionSearchService: ReportsDashboardSearchService,
        private coverageAnalysisService: CoverageAnalysisService,
        private messageService: MessageService,
        private localizationService: LocalizationService,
        private userStateService: CurrentUserStateService,
        private fb: FormBuilder,
    ) {
        this.overlayContainer = document.getElementById('main-content');
        this.setSubscriptions();
    }
    ngOnInit(): void {
        this.settingsForm = this.fb.group({
            representation: [''],
            position: [''],
            contentType: [null],
            goal: [null],
            targetAudience: [null],
            tone: [null],
            language: [null],
        });

        this.contentTypeOptions$ = of(
            Object.values(ContentTypeEnum).map(value => ({
                value,
                label: this.localizationService.transform(`Reports.actionAssistant.settings.contentType.${value}`)
            }))
        );

        this.goalOptions$ = of(
            Object.values(GoalTypeEnum).map(value => ({
                value,
                label: this.localizationService.transform(`Reports.actionAssistant.settings.goal.${value}`)
            }))
        );

        this.targetAudienceOptions$ = of(
            (Object.values(CompletionTargetAudienceEnum) as CompletionTargetAudienceEnum[])
                .filter(value => value !== CompletionTargetAudienceEnum.CUSTOM)
                .map(value => ({
                    value,
                    label: this.localizationService.transform(`Reports.actionAssistant.settings.targetAudience.${value}`)
                }))
        );

        this.toneOptions$ = of(
            (Object.values(CompletionToneEnum) as CompletionToneEnum[])
                .filter(value => value !== CompletionToneEnum.CUSTOM)
                .map(value => ({
                    value,
                    label: this.localizationService.transform(`Reports.actionAssistant.settings.tone.${value}`)
                }))
        );

        const languageOptions = this.promptLanguageOptions.map(option => ({
            value: option.value,
            label: languageDataLocalizationMap[option.label] ?? option.label
        }));
        this.languageOptions$ = of(languageOptions);

        const defaultLanguage = languageOptions.find(opt => opt.value === this.selectedLanguage?.value);
        if (defaultLanguage) {
            this.settingsForm.get('language').setValue(defaultLanguage);
        }

        this.ckEditorConfig = new RichTextEditorConfigModel({
            enableFontFamily: true,
            enableFontSize: true,
            enableLineHeight: true,
            enableHeading: true,
            enableFontColor: true,
            enableBackgroundColor: true,
            enableIndent: true,
            enableBlockQuote: true,
            enableAIRefinement: true,
            enableHtmlEditor: true,
            enableInsertImage: true,
            enableAlignment: true,
            enableStrikethrough: true,
            enableNumberedList: true,
            enableDirection: true,
            enableTranslation: true,
            enableAIHelper: true,
            aiReferenceId: ''
        });

        this.sourceChanged(this.drilldownSeries, false);
    }

    /**
         * Sets subscriptions, pushing to array for easy cleanup later
         */
    private setSubscriptions(): void {
        this.subscriptions.push(
            this.monitorConfigService.getHasCoverageInsightsEnabled().subscribe(x => {
                this.hasCoverageInsightsEnabled = x;
            }),
            this.monitorConfigService.getSearchRange().subscribe(
                searchRange => {
                    this.searchRange = searchRange;
                }
            ),
            this.mentionSearchService.getDateQuery().subscribe(dateQuery => {
                this.dateQuery = dateQuery;
                this.clearState();
            }),
            this.mentionSearchService.getItemCount().subscribe(search => {
                this.mentionCount = search;
            }),
            combineLatest(
                [
                    this.mentionSearchService.getSearchState(),
                    this.mentionSearchService.getSearchCriteria()
                ]
            ).subscribe(
                ([searchState, searchCriteria]) => {
                    this.loading = searchState.type === SearchStatesEnum.loading;
                    if (this.loading && this.cachedSearchCriteria && !this.cachedSearchCriteria.equals(searchCriteria) ) {
                        this.clearState();
                    }

                    this.cachedSearchCriteria = searchCriteria?.clone();
                    this.skipClearState = false;
                }
            ),
            this.userStateService.getPreferences().subscribe(preference => {
                if (preference?.uiLanguage) {
                    if (preference.uiLanguage.languageTag === 'fr-FR') {
                        preference.uiLanguage.languageTag = 'fr';
                    }
                    this.selectedLanguage = this.promptLanguageOptions.find(x => x.value === preference.uiLanguage.languageTag);
                } else {
                    this.selectedLanguage = this.promptLanguageOptions.find(x => x.value === 'en-US');
                }
            }),
            this.userStateService.getUILanguageTag().subscribe(tag => {
                this.promptLanguageOptions.forEach(option => {
                    option.label = tag + '.' + option.value;
                });
            })
        );
    }

    analyzeCoverage(event): void {
        if (this.hasCoverageInsightsEnabled) {
            this.loading = true;
            const coverageInsights = new CoverageInsights();
            coverageInsights.aiAnalysisType = AiAnalysisTypes.COLLECTION_KEY_MESSAGES_DEFAULT;
            coverageInsights.focus = this.analysisContext;
            this.coverageAnalysisService.getKeyMessages(
                coverageInsights,
                this.mentionSearchService.getMentionSearchCriteriaPayload()
            ).pipe(
                catchError(e => {
                    this.loading = false;
                    // eslint-disable-next-line max-len
                    if (e?.error?.details?.length && e?.error?.details?.[0].invalidValue === 'Invalid request, the number of mentions that allow ai process is 0.' ) {
                        this.messageService.add({
                            severity : messageSeverityEnum.error,
                            summary : this.localizationService.transform('Reports.coverageInsight.error.noMentionAllowed.summary'),
                            detail: this.localizationService.transform('Reports.coverageInsight.error.noMentionAllowed.detail')
                        });
                    } else {
                        this.errorMessage();
                    }

                    throw e;
                })).subscribe(keyMessages => {
                this.keyMessageGroups = keyMessages;
                this.keyMessageGroupsChanged.emit(this.keyMessageGroups);
                this.resetScrollPanel();
                if (this.keyMessageGroups?.length) {
                    // by default, selected the first key narrative
                    this.selectKeyMessage(this.keyMessageGroups[0]);
                }

                this.loading = false;
            });
        } else {
            const mousePositionX = (event as PointerEvent)?.clientX || 0;
            const mousePositionY = (event as PointerEvent)?.clientY || 0;
            const ioModel = this.coreDialogService.getIoConfigBasedOnMousePosition(mousePositionX, mousePositionY, this.aiPopupWidth, this.aiPopupHeight);
            ioModel.inputs.overlayContainer = this.overlayContainer;
            ioModel.inputs.message = 'Reports.coverageInsight.upSell.message';
            ioModel.inputs.bullets = [
                'Reports.coverageInsight.upSell.bullet1',
                'Reports.coverageInsight.upSell.bullet2',
                'Reports.coverageInsight.upSell.bullet3'
            ];
            this.coreDialogService.open(AnalysisUpsellPopupComponent, ioModel, this.injector);
        }
    }

    applyUserDefinedKeyMessage(): void {
        this.loading = true;
        const coverageInsights = new CoverageInsights();
        coverageInsights.aiAnalysisType = AiAnalysisTypes.COLLECTION_KEY_MESSAGES_USER_DEFINED;
        coverageInsights.userDefinedKeyMessage = this.userDefinedKeyMessageString;
        this.coverageAnalysisService.getUserDefinedKeyMessages(
            coverageInsights,
            this.mentionSearchService.getMentionSearchCriteriaPayload(),
            this.drilldownSeries.isSavedSource()
        ).pipe(catchError(e => {
            this.loading = false;
            this.errorMessage();

            throw e;
        })).subscribe(keyMessages => {
            const userDefinedKeyMessages = new KeyMessageGroupApi();
            userDefinedKeyMessages.keyMessageGroupTitle = this.userDefinedKeyMessageString;
            let ids = [];
            let maxExampleSize = 0;
            keyMessages?.forEach(keyMessage => {
                let examples = [];
                if (keyMessage?.examples?.length) {
                    examples = keyMessage.examples.filter(x => !!x);
                    ids.push(...examples);
                }

                if (keyMessage.summary && examples.length > maxExampleSize) {
                    maxExampleSize = examples.length;
                    userDefinedKeyMessages.keyMessageGroupSummary = keyMessage.summary;
                }
            });

            ids = ids.filter((item, index) => ids.indexOf(item) === index);
            if (ids.length > 400) {
                ids = ids.slice(0, 400);
            }
            userDefinedKeyMessages.examples = ids;

            if (!ids.length) {
                userDefinedKeyMessages.keyMessageGroupSummary = this.localizationService.transform(
                    'Reports.coverageInsight.userDefinedMessage.noResult.summary', {keyMessage: this.userDefinedKeyMessageString}
                );
            }

            this.keyMessageGroups.push(userDefinedKeyMessages);
            this.keyMessageGroupsChanged.emit(this.keyMessageGroups);
            this.showBackButton = this.keyMessageGroups.length === 1 && !this.keyMessageGroups[0].examples?.length;
            this.loading = false;
            this.collapsed = true;
            this.userDefinedKeyMessageString = '';
            this.selectKeyMessage(userDefinedKeyMessages);
        });
    }

    private errorMessage() {
        this.messageService.add({
            severity : messageSeverityEnum.error,
            summary : this.localizationService.transform('Reports.coverageInsight.error.genericSummary'),
            detail: this.localizationService.transform('Reports.coverageInsight.error.genericDetail')
        });
    }

    sourceChanged(series: ReportSeriesModel, doEmit: boolean = true) {
        this.clearState();
        this.resetContentSettings();

        if (series?.isSavedSource()) {
            this.dateOptions = getMonitoringDateQueryInputFolderOptions();
        } else {
            this.dateOptions = getMonitoringDateQueryInputTopicOptions();
            if (this.dateQuery.type === DateQueryTypeEnum.ALL) {
                this.dateQuery = this.dateOptions[0].value.query;
            }
        }

        if (doEmit) {
            this.emitSourceChanged.next(series);
        }
    }

    clearState(): void {
        if (this.skipClearState) {
            return;
        }

        this.mentionCount = 0;
        this.backToAnalysis();
    }

    resetContentSettings(): void {
        this.settingsForm?.patchValue({
            representation: '',
            position: '',
            contentType: null,
            goal: null,
            targetAudience: null,
            tone: null,
        });
        this.hasGenerated = false;
        this.generatedResponse = null;
        this.generatedContentType = null;
        this.generatedContentTypeLabel = '';
    }

    backToAnalysis(): void {
        this.showBackButton = false;
        this.keyMessageGroups = [];
        this.keyMessageGroupsChanged.emit(this.keyMessageGroups);
        this.collapsed = true;
    }

    public ngOnDestroy(): void {
        this.subscriptions.forEach(
            subscription => {
                subscription.unsubscribe();
            }
        );
    }

    /**
     * Performs the toggle animation
     */
    toggle(event) {
        if (event instanceof KeyboardEvent && !(event.key === ActionKeys.ENTER || event.key === ActionKeys.SPACE)) {
            return;
        }

        if (this.animating) {
            return false;
        }

        this.animating = true;


        if (this.collapsed) {
            this.collapsed = false;
        } else {
            this.collapsed = true;
        }

    }

    onToggleDone(): void {
        this.animating = false;
    }

    /**
     * updates the date range and re-runs the search
     *
     * @param dateRange
     *
     * @returns void
     */
    dateRangeChanged(): void {
        this.clearState();
        this.dateChanged.next(this.dateQuery);
    }

    selectKeyMessage(keyMessageGroup: KeyMessageGroupApi): void {
        if (keyMessageGroup.selected) {
            return;
        }

        this.keyMessageGroups.forEach(x => x.selected = false);
        keyMessageGroup.selected = true;
        this.settingsForm.get('position')?.setValue('');
    }

    get isEmailOutput(): boolean {
        return this.generatedContentType === ContentTypeEnum.EMAIL;
    }

    get isCreateDistributionOutput(): boolean {
        return [ContentTypeEnum.EMAIL, ContentTypeEnum.PRESS_RELEASE].includes(this.generatedContentType);
    }


    get isHeadlineOutput(): boolean {
        return [ContentTypeEnum.FACEBOOK, ContentTypeEnum.REDDIT].includes(this.generatedContentType);
    }

    get isGenerateDisabled(): boolean {
        const { contentType } = this.settingsForm.value;
        const selectedKeyMessage = this.keyMessageGroups?.find(g => g.selected);
        if (selectedKeyMessage && !selectedKeyMessage.examples?.length) {
            return true;
        }
        const hasContentType = contentType && (typeof contentType === 'object' || (typeof contentType === 'string' && contentType.trim()));
        return !hasContentType;
    }

    get generateDisabledTooltip(): string {
        const selectedKeyMessage = this.keyMessageGroups?.find(g => g.selected);
        if (selectedKeyMessage && !selectedKeyMessage.examples?.length) {
            return this.localizationService.transform('Reports.actionAssistant.settings.generate.noMatches.tooltip');
        }

        if (!this.isGenerateDisabled) {
            return '';
        }

        const field = this.localizationService.transform('Reports.actionAssistant.settings.contentType');

        return this.localizationService.transform(
            'Reports.actionAssistant.settings.generate.disabled.tooltip',
            { fields: field }
        );
    }

    generateContent(): void {
        const formValue = this.settingsForm.value;
        const selectedKeyMessage = this.keyMessageGroups.find(x => x.selected);

        const coverageInsights = new CoverageInsights();
        coverageInsights.aiAnalysisType = AiAnalysisTypes.COVERAGE_ACTION_ASSISTANT;
        coverageInsights.representation = formValue.representation;
        coverageInsights.position = formValue.position;
        const contentTypeOption = formValue.contentType;
        const goalOption = formValue.goal;
        const targetAudienceOption = formValue.targetAudience;
        const toneOption = formValue.tone;

        coverageInsights.contentType = (contentTypeOption && typeof contentTypeOption === 'object') ? contentTypeOption.value : null;
        coverageInsights.customContentType = (contentTypeOption && typeof contentTypeOption === 'string') ? contentTypeOption : undefined;
        coverageInsights.goal = (goalOption && typeof goalOption === 'object') ? goalOption.value : null;
        coverageInsights.customGoal = (goalOption && typeof goalOption === 'string') ? goalOption : undefined;
        coverageInsights.targetAudience = (targetAudienceOption && typeof targetAudienceOption === 'object') ? targetAudienceOption.value : null;
        coverageInsights.customTargetAudience = (targetAudienceOption && typeof targetAudienceOption === 'string') ? targetAudienceOption : undefined;
        coverageInsights.completionTone = (toneOption && typeof toneOption === 'object') ? toneOption.value : null;
        coverageInsights.customTone = (toneOption && typeof toneOption === 'string') ? toneOption : undefined;
        const languageOption = formValue.language;
        coverageInsights.selectedLanguageOption = (languageOption && typeof languageOption === 'object') ? languageOption : null;
        coverageInsights.customLanguage = (languageOption && typeof languageOption === 'string') ? languageOption : undefined;

        coverageInsights.keyMessageTitle = selectedKeyMessage?.keyMessageGroupTitle;
        coverageInsights.keyMessageSummary = selectedKeyMessage?.keyMessageGroupSummary;

        const mentionIds = selectedKeyMessage?.examples ?? [];

        this.loading = true;
        this.coverageAnalysisService.generateCoverageInsight(
            coverageInsights,
            mentionIds,
            this.drilldownSeries.isSavedSource()
        ).pipe(
            catchError(e => {
                this.loading = false;
                this.errorMessage();
                throw e;
            })
        ).subscribe((response: BulkAnalysisResponseApi) => {
            this.loading = false;
            this.hasGenerated = true;
            this.generatedResponse = response.json ? JSON.parse(response.json) as ActionAssistantResponseApi : {};
            if (response.html && !this.generatedResponse.body) {
                this.generatedResponse.body = response.html;
            }
            this.generatedResponse.body = this.applyContentSpacing(this.generatedResponse.body ?? '');
            this.generatedContentType = (contentTypeOption && typeof contentTypeOption === 'object') ? contentTypeOption.value : null;
            this.generatedContentTypeLabel = (contentTypeOption && typeof contentTypeOption === 'object')
                ? contentTypeOption.label
                : (contentTypeOption ?? '');
            requestAnimationFrame(() => this.contentScrollPanel?.scrollTo());
        });
    }

    generatePositionSuggestions(buttonEl: HTMLElement): void {
        const selectedKeyMessage = this.keyMessageGroups.find(x => x.selected);
        if (!selectedKeyMessage) {
            return;
        }

        const rect = buttonEl.getBoundingClientRect();
        this.positionSuggestionsTop = rect.top - 5;
        this.positionSuggestionsLeft = rect.right + 20;

        const coverageInsights = new CoverageInsights();
        coverageInsights.aiAnalysisType = AiAnalysisTypes.POSITION_SUGGESTION;
        coverageInsights.representation = this.settingsForm.get('representation').value;
        coverageInsights.keyMessageTitle = selectedKeyMessage.keyMessageGroupTitle;
        coverageInsights.keyMessageSummary = selectedKeyMessage.keyMessageGroupSummary;

        this.loadingPositionSuggestions = true;
        this.coverageAnalysisService.generateCoverageInsight(
            coverageInsights,
            selectedKeyMessage.examples,
            this.drilldownSeries.isSavedSource()
        ).pipe(
            catchError(e => {
                this.loadingPositionSuggestions = false;
                this.errorMessage();
                throw e;
            })
        ).subscribe(response => {
            this.loadingPositionSuggestions = false;

            const parsed = JSON.parse(response.json);
            this.positionSuggestions = parsed.positions ?? [];
        });
    }

    selectPositionSuggestion(suggestion: PositionSuggestionApi): void {
        this.settingsForm.get('position').setValue(suggestion.position);
        this.positionSuggestions = [];

        requestAnimationFrame(() => {
            const textarea = this.positionFieldEl?.nativeElement?.querySelector('textarea');
            textarea?.focus();
        });
    }

    closePositionSuggestions(): void {
        this.positionSuggestions = [];
        this.loadingPositionSuggestions = false;
    }

    onAiButtonTab(e: KeyboardEvent): void {
        if (!e.shiftKey && (this.loadingPositionSuggestions || this.positionSuggestions.length)) {
            e.preventDefault();
            if (this.positionSuggestions.length) {
                const firstItem = this.positionSuggestionsListEl?.nativeElement?.querySelector('li');
                firstItem?.focus();
            } else {
                this.positionSuggestionsPopupEl?.nativeElement?.focus();
            }
        }
    }

    onPositionSuggestionsPopupTab(e: KeyboardEvent): void {
        e.preventDefault();
        if (e.shiftKey) {
            const button = this.aiButtonEl?.nativeElement?.querySelector('button');
            button?.focus();
        } else {
            const input = this.contentTypeFieldEl?.nativeElement?.querySelector('input');
            input?.focus();
        }
    }

    onPositionSuggestionsTab(e: KeyboardEvent): void {
        e.preventDefault();
        if (e.shiftKey) {
            const button = this.aiButtonEl?.nativeElement?.querySelector('button');
            button?.focus();
        } else {
            this.closePositionSuggestions();
            requestAnimationFrame(() => {
                const input = this.contentTypeFieldEl?.nativeElement?.querySelector('input');
                input?.focus();
            });
        }
    }

    resetOutput(): void {
        this.hasGenerated = false;
        this.generatedResponse = null;
        this.generatedContentType = null;
        this.generatedContentTypeLabel = '';
    }

    copyAll(): void {
        const r = this.generatedResponse;
        if (!r) {
            return;
        }

        const textParts: string[] = [];
        const htmlParts: string[] = [];
        const label = (key: string) => this.localizationService.transform(`Reports.actionAssistant.output.${key}`);

        if (this.isCreateDistributionOutput) {
            if (r.subjectLine) {
                const l = label('subjectLine');
                textParts.push(`${l}: ${r.subjectLine}`);
                htmlParts.push(`<p><strong>${l}:</strong> ${r.subjectLine}</p>`);
            }
            if (r.previewText) {
                const l = label('previewText');
                textParts.push(`${l}: ${r.previewText}`);
                htmlParts.push(`<p><strong>${l}:</strong> ${r.previewText}</p>`);
            }
        }

        if (this.isHeadlineOutput && r.headline) {
            const l = label('headline');
            textParts.push(`${l}: ${r.headline}`);
            htmlParts.push(`<p><strong>${l}:</strong> ${r.headline}</p>`);
        }

        if (r.body) {
            const bodyLabel = label('body');
            const bodyText = this.htmlToPlainText(r.body);
            textParts.push(`${bodyLabel}:\n${bodyText}`);
            htmlParts.push(`<p><strong>${bodyLabel}:</strong></p>${r.body}`);
        }

        const htmlBlob = new Blob([htmlParts.join('')], { type: 'text/html' });
        const textBlob = new Blob([textParts.join('\n\n')], { type: 'text/plain' });
        const clipboardItem = new ClipboardItem({ [htmlBlob.type]: htmlBlob, [textBlob.type]: textBlob });
        navigator.clipboard.write([clipboardItem]).then(() => {
            this.messageService.add({
                severity: messageSeverityEnum.success,
                detail: this.localizationService.transform('Reports.actionAssistant.output.copyAll.success')
            });
        });
    }


    private applyContentSpacing(html: string): string {
        if (!html) {
            return html;
        }
        // CKEditor 5 has a strict block model: all content must live inside a block element.
        // A <br> between block elements is orphaned inline content, so CKEditor wraps it in
        // a <p> and adds &nbsp; as a filler, producing <p><br>&nbsp;</p>.
        // We strip inter-block <br> in both directions before CKEditor processes the HTML.
        const doc = new DOMParser().parseFromString(html, 'text/html');
        let body = doc.body.innerHTML
            // Convert \n to <br> (some AI responses use newlines for spacing).
            .replace(/\n/g, '<br>')
            // Collapse consecutive <br> runs to one.
            .replace(/(<br\s*\/?>\s*){2,}/gi, '<br>')
            // Strip <br> that immediately follows a block-level closing tag.
            .replace(/<\/(p|ul|ol|li|h[1-6])>\s*<br\s*\/?>/gi, '</$1>')
            // Strip <br> that immediately precedes a block-level opening tag.
            .replace(/<br\s*\/?>(?=\s*<(p|ul|ol|li|h[1-6])[\s>])/gi, '');

        body = this.applyHeadingLineHeight(body);

        // Add <p>&nbsp;</p> after </ul>/</ol> as a single-line spacer.
        // <br> is avoided because CKEditor inflates it to <p><br>&nbsp;</p> (double-height).
        // Lookahead guard prevents inserting duplicate spacers.
        body = body.replace(/<\/(ul|ol)>(?!<p>&nbsp;<\/p>)/gi, '</$1><p>&nbsp;</p>');

        return body;
    }

    // Sets line-height:2 on all heading tags, replacing any existing value.
    private applyHeadingLineHeight(html: string): string {
        if (!html) {
            return html;
        }
        return html.replace(/<(h[1-6])(\s[^>]*)?>/gi, (_match, tag, attrs = '') => {
            const withoutLineHeight = attrs.replace(/\s*line-height\s*:\s*[^;"']*/gi, '');
            const styleMatch = withoutLineHeight.match(/style="([^"]*)"/);
            if (styleMatch) {
                return `<${tag}${withoutLineHeight.replace(/style="[^"]*"/, `style="${styleMatch[1]};line-height:2"`)}>`;
            }
            return `<${tag}${withoutLineHeight} style="line-height:2">`;
        });
    }

    private htmlToPlainText(html: string): string {
        return html
            .replace(/<\/p>/gi, '\n\n')
            .replace(/<\/h[1-6]>/gi, '\n\n')
            .replace(/<br\s*\/?>/gi, '\n')
            .replace(/<\/li>/gi, '\n')
            .replace(/<\/[uo]l>/gi, '\n')
            .replace(/<[^>]+>/g, '')
            .replace(/&amp;/g, '&')
            .replace(/&lt;/g, '<')
            .replace(/&gt;/g, '>')
            .replace(/&quot;/g, '"')
            .replace(/&#39;/g, '\'')
            .replace(/&nbsp;/g, ' ')
            .replace(/\n{3,}/g, '\n\n')
            .trim();
    }

    openEmail(): void {
        const rawSubject = this.isCreateDistributionOutput
            ? (this.generatedResponse?.subjectLine ?? '')
            : (this.generatedResponse?.headline ?? '');

        const rawBody = this.generatedResponse?.body ?? '';
        const plainBody = this.htmlToPlainText(rawBody);

        const subject = encodeURIComponent(rawSubject);
        const body = encodeURIComponent(plainBody);
        window.open(`mailto:?subject=${subject}&body=${body}`, '_blank');
    }

    createDistribution(): void {
        const r = this.generatedResponse;
        const content: AiDistributionContent = {
            subjectLine: r.subjectLine,
            previewText: r.previewText,
            headline: r.headline,
            body: r.body,
        };
        const key = 'aiDistributionContent_' + Date.now();
        localStorage.setItem(key, JSON.stringify(content));
        window.open(`Discover/distributions/distribution?newDistributionContentKey=${key}`, '_blank');
    }

    cancelGeneration(prompt: PromptModel): void {
        if (prompt.destroyApiCall$) {
            prompt.destroyApiCall$.next();
        }
        if(prompt.apiCall) {
            prompt.apiCall.unsubscribe();
        }
        prompt.generating = false;
    }
    // This might be a bug from primeng, sometimes initial load, there is a wired scrollbar, below code resolve it
    resetScrollPanel(): void {
        requestAnimationFrame(() => {
            this.keyMessageScrollPanel?.scrollTo();
            this.settingsScrollPanel?.scrollTo();
            this.contentScrollPanel?.scrollTo();
        });
    }
}

